module.exports = __webpack_public_path__ + "media/images/story/top/point_image_3-f6ca817863175b415d663d7eeb730b35.jpg";